const defaultItem = (icon) => ({
  icon,
  title: 'Collaborate Effectively',
  text:
    'CastleCMS was built for large team collaboration. Fine-grained security for group editing and viewing, versioning, tagging, and content quality checks: all the features you need to create and manage content worthy of any enterprise.',
});

const schema = ({ intl }) => ({
  title: intl.formatMessage({ id: 'HP Features', defaultMessage: 'HP Features' }),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage({ id: 'Default', defaultMessage: 'Default' }),
      fields: ['items', 'imagePosition', 'minHeight'],
    },
  ],
  properties: {
    minHeight: {
      title: intl.formatMessage({ id: 'Min height (px)', defaultMessage: 'Min height (px)' }),
      type: 'number',
      default: 520,
    },
    imagePosition: {
      title: intl.formatMessage({ id: 'Image position', defaultMessage: 'Image position' }),
      type: 'string',
      default: 'right center',
    },
    items: {
      title: intl.formatMessage({ id: 'Items', defaultMessage: 'Items' }),
      widget: 'object_list',
      schema: {
        title: intl.formatMessage({ id: 'Item', defaultMessage: 'Item' }),
        fieldsets: [
          {
            id: 'default',
            title: intl.formatMessage({ id: 'Item', defaultMessage: 'Item' }),
            fields: ['icon', 'title', 'text'],
          },
        ],
        properties: {
          icon: {
            title: intl.formatMessage({ id: 'Icon', defaultMessage: 'Icon' }),
            type: 'string',
            description: 'Icon key: wrench | calendar | mobile',
            default: 'wrench',
          },
          title: {
            title: intl.formatMessage({ id: 'Title', defaultMessage: 'Title' }),
            type: 'string',
          },
          text: {
            title: intl.formatMessage({ id: 'Text', defaultMessage: 'Text' }),
            widget: 'textarea',
          },
        },
        required: ['title'],
      },
      default: [
        defaultItem('wrench'),
        {
          icon: 'calendar',
          title: 'Theming, Your Way',
          text:
            'Create and modify your website theme live, using only a web browser, with the freedom to customize all aspects of CastleCMS. Apply your corporate brand exactly as you envisioned, with the most powerful and flexible theming engine available.',
        },
        {
          icon: 'mobile',
          title: 'Social Media Integration',
          text:
            'Engage your users, customers and audience more effectively than ever before, using CastleCMS built-in social media platform integrations: Facebook, Twitter, Pinterest, Instagram, Google Plus, YouTube, AddThis, Disqus, GitHub, and more',
        },
      ],
    },
  },
  required: [],
});

export default schema;